module.exports = __webpack_public_path__ + "static/media/BG_28.8426de37.png";